import { render } from "./Counsel.vue?vue&type=template&id=fca2a0ec"
import script from "./Counsel.vue?vue&type=script&lang=js"
export * from "./Counsel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__